import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';

import { CoreModule } from '../core/core.module';

import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { SlideMenuModule } from 'primeng/slidemenu';
import { TableModule } from 'primeng/table';
import { FloatLabelModule } from 'primeng/floatlabel';

import { CaliforniaCompliancePageComponent } from './purchase-order/compliance-pages/usa-pages/california-compliance-page/california-compliance-page.component';
import { CaptureSignatureComponent } from './purchase-order/capture-signature/capture-signature.component';
import { FormInputFieldErrorComponent } from './form-input-field-error/form-input-field-error.component';
import { HeaderComponent } from './header/header.component';
import { IllinoisCompliancePageComponent } from './purchase-order/compliance-pages/usa-pages/illinois-compliance-page/illinois-compliance-page.component';
import { LocationToolbarComponent } from './header/location-toolbar/location-toolbar.component';
import { PurchaseOrderComponent } from './purchase-order/purchase-order/purchase-order.component';
import { PurchaseOrderPDFComponent } from './purchase-order/purchase-order-pdf/purchase-order-pdf.component';
import { PurchaseOrderToolbarComponent } from './header/purchase-order-toolbar/purchase-order-toolbar.component';
import { TableHeaderComponent } from './table-header/table-header.component';
import { WaitingIndicatorComponent } from './waiting-indicator/waiting-indicator.component';
import { TexasCompliancePageComponent } from './purchase-order/compliance-pages/usa-pages/texas-compliance-page/texas-compliance-page.component';
import { WestVirginiaCompliancePageComponent } from './purchase-order/compliance-pages/usa-pages/west-virginia-compliance-page/west-virginia-compliance-page.component';
import { SidebarModule } from 'primeng/sidebar';
// tslint:disable-next-line:max-line-length
import { DefaultCompliancePageComponent } from './purchase-order/compliance-pages/usa-pages/default-compliance-page/default-compliance-page.component';
import { PdfWriter } from './pdf-utils/pdf-writer';
import { InputMaskModule } from 'primeng/inputmask';
import { LogListComponent } from './user-logs/log-list/log-list.component';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { SubsidiaryToolbarComponent } from './header/subsidiary-toolbar/subsidiary-toolbar.component';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { CurrencyConvertPipe } from '../services/custom-currency.pipe';
import { UkCompliancePageComponent } from './purchase-order/compliance-pages/eu-pages/uk-compliance-page/uk-compliance-page.component';
import { FieldsetComponent } from './purchase-order/compliance-pages/eu-pages/uk-compliance-page/fieldset/fieldset.component';
import { PaymentTypesSelectionComponent } from "./purchase-order/compliance-pages/payment-types-selection/payment-types-selection.component";
import { VehicleInfoComponent } from './purchase-order/compliance-pages/vehicle-info/vehicle-info/vehicle-info.component';
import { MissisipiCompliancePageComponent } from './purchase-order/compliance-pages/usa-pages/missisipi-compliance-page/missisipi-compliance-page.component';
import { NgxImageCompressService } from 'ngx-image-compress';
import { DialogModule } from 'primeng/dialog';
import { AdminEditComponent } from './purchase-order/admin-edit/admin-edit.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@NgModule({
    declarations: [
        CaliforniaCompliancePageComponent,
        CaptureSignatureComponent,
        FormInputFieldErrorComponent,
        HeaderComponent,
        IllinoisCompliancePageComponent,
        LocationToolbarComponent,
        LogListComponent,
        PurchaseOrderComponent,
        PurchaseOrderPDFComponent,
        PurchaseOrderToolbarComponent,
        TableHeaderComponent,
        WaitingIndicatorComponent,
        TexasCompliancePageComponent,
        DefaultCompliancePageComponent,
        MissisipiCompliancePageComponent,
        WestVirginiaCompliancePageComponent,
        UkCompliancePageComponent,
        SubsidiaryToolbarComponent,
        FieldsetComponent,
        PaymentTypesSelectionComponent,
        VehicleInfoComponent,
        AdminEditComponent
    ],
    imports: [
    OverlayPanelModule,
    CommonModule,
    CoreModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    SidebarModule,
    RouterModule,
    CalendarModule,
    CheckboxModule,
    ConfirmDialogModule,
    DialogModule,
    ConfirmPopupModule,
    DropdownModule,
    FileUploadModule,
    InputMaskModule,
    InputNumberModule,
    InputTextModule,
    MenubarModule,
    MenuModule,
    MessageModule,
    MessagesModule,
    SlideMenuModule,
    TieredMenuModule,
    TableModule,
    AngularSignaturePadModule,
    CurrencyConvertPipe,
    NgTemplateOutlet,
    FloatLabelModule,
],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        SidebarModule,
        CaptureSignatureComponent,
        SubsidiaryToolbarComponent,
        AngularSignaturePadModule,

        CalendarModule,
        CheckboxModule,
        ConfirmDialogModule,
        ConfirmPopupModule,
        DropdownModule,
        FileUploadModule,
        InputMaskModule,
        InputNumberModule,
        InputTextModule,
        MenuModule,
        MessageModule,
        MessagesModule,
        SlideMenuModule,
        TieredMenuModule,
        TableModule,

        FormInputFieldErrorComponent,
        HeaderComponent,
        LogListComponent,
        PurchaseOrderComponent,
        TableHeaderComponent,
        WaitingIndicatorComponent,
        FieldsetComponent,
    ],
    providers: [ DatePipe, PdfWriter, CurrencyConvertPipe, DecimalPipe, NgxImageCompressService ]
})
export class CoreUiModule {}
